import industriesPlaceholder from '@/assets/images/industries_placeholder.svg';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 120px;
`;

const MessageWrapper = styled.div`
    max-width: 314px;
    font-size: 18px;
    text-align: center;
    color: ${({ theme }) => theme.gray_3};
    margin-top: 24px;
`;

const IndustriesPlaceholderImage = styled.img`
    width: 314px;
`;

const defaultMessage =
    'To see results on this page, choose a category in the top filters...';

function IndustriesPlaceholderMessage({ message = defaultMessage }) {
    return (
        <Wrapper>
            <IndustriesPlaceholderImage
                src={industriesPlaceholder}
                css="width: 314px;"
            />
            <MessageWrapper>{message}</MessageWrapper>
        </Wrapper>
    );
}

export default IndustriesPlaceholderMessage;
